import mock from '@/fake-db/mock.js'

const cameras = [
  {
    "id": 1,
    "code": "#2545454",
    "manager": "Tom Hank",
    "name": "Playground",
    "color_code": "#4a0d66",
    "setting":
    {
      'max_daily_logins': 12,
    },
    locations: [{
      "id": 1,
      "name": "The Bronx",
      "manager": "Tom Hank",
      "settings":
      {
        'max_daily_logins': 13,
        'user_time_out': '1 hr',
      }
    },
    {
      "id": 2,
      "name": "Manhattan",
      "manager": "Quinn Reily",
      "settings":
      {
        'max_daily_logins': 12,
        'user_time_out': '30 min',

      }
    },]
  },
  {
    "id": 3,
    "code": "#zdf42342",
    "name": "Office",
    "color_code": "#1bc546",
    "setting":
    {
      'max_daily_logins': 10,
    },
    locations: [
      {
        "id": 2,
        "name": "Manhattan",
        "manager": "Quinn Reily",
        "settings":
        {
          'max_daily_logins': 12,
          'user_time_out': '30 min',

        }
      },]
  },
];
const cam_students = []

const data = {
  products: [
    {
      'id': 1,
      'category': 'computers',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/01.png',
      'name': 'Apple Watch series 4 GPS',
      'order_status': 'on_hold',
      'popularity': 97,
      'price': 69.99
    },
    {
      'id': 2,
      'category': 'fitness',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/02.png',
      'name': 'Beats HeadPhones',
      'order_status': 'delivered',
      'popularity': 83,
      'price': 69.99
    },
    {
      'id': 3,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/06.png',
      'name': 'Altec Lansing - Bluetooth Speaker',
      'order_status': 'canceled',
      'popularity': 57,
      'price': 199.99
    },
    {
      'id': 4,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/09.png',
      'name': 'Altec Lansing - Bluetooth Speaker',
      'order_status': 'delivered',
      'popularity': 65,
      'price': 199.99
    },
    {
      'id': 5,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/06.png',
      'name': 'Altec Lansing - Portable Bluetooth Speaker',
      'order_status': 'canceled',
      'popularity': 87,
      'price': 199.99
    },
    {
      'id': 6,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/09.png',
      'name': 'Altec Lansing - Bluetooth Speaker',
      'order_status': 'canceled',
      'popularity': 55,
      'price': 39.99
    },
    {
      'id': 7,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/02.png',
      'name': 'Altec Lansing - Mini H2O Bluetooth Speaker',
      'order_status': 'on_hold',
      'popularity': 99,
      'price': 39.99
    },
    {
      'id': 8,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/09.png',
      'name': 'Altec Lansing - Bluetooth Speaker',
      'order_status': 'canceled',
      'popularity': 91,
      'price': 39.99
    },
    {
      'id': 9,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/05.png',
      'name': 'Altec Lansing - Mini H2O Bluetooth Speaker',
      'order_status': 'delivered',
      'popularity': 52,
      'price': 39.99
    },
    {
      'id': 10,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/01.png',
      'name': 'Altec Lansing - Mini H2O Bluetooth Speaker',
      'order_status': 'canceled',
      'popularity': 64,
      'price': 39.99
    },
    {
      'id': 11,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/05.png',
      'name': 'Altec Lansing - Bluetooth Speaker',
      'order_status': 'canceled',
      'popularity': 93,
      'price': 99.99
    },
    {
      'id': 12,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/01.png',
      'name': 'Altec Lansing - Bluetooth Speaker',
      'order_status': 'pending',
      'popularity': 75,
      'price': 99.99
    },
    {
      'id': 13,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/01.png',
      'name': 'Altec Lansing - Bluetooth Speaker',
      'order_status': 'delivered',
      'popularity': 88,
      'price': 99.99
    },
    {
      'id': 14,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/09.png',
      'name': 'Altec Lansing - Bluetooth Speaker',
      'order_status': 'delivered',
      'popularity': 86,
      'price': 99.99
    },
    {
      'id': 15,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/05.png',
      'name': 'Aluratek - Bluetooth Audio Receiver',
      'order_status': 'on_hold',
      'popularity': 62,
      'price': 29.99
    },
    {
      'id': 16,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/04.png',
      'name': 'Aluratek - Bluetooth Audio Transmitter',
      'order_status': 'canceled',
      'popularity': 51,
      'price': 29.99
    },
    {
      'id': 17,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/07.png',
      'name': 'Aluratek - iStream Bluetooth Audio Receiver',
      'order_status': 'pending',
      'popularity': 51,
      'price': 29.99
    },
    {
      'id': 18,
      'category': 'computers',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/07.png',
      'name': 'Antec - Nano Diamond Thermal Compound',
      'order_status': 'on_hold',
      'popularity': 65,
      'price': 14.99
    },
    {
      'id': 19,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/05.png',
      'name': 'Antec - SmartBean Bluetooth Adapter',
      'order_status': 'on_hold',
      'popularity': 63,
      'price': 39.99
    },
    {
      'id': 20,
      'category': 'fitness',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/09.png',
      'name': 'Basis - Peak Fitness and Sleep Tracker',
      'order_status': 'on_hold',
      'popularity': 72,
      'price': 199.99
    },
    {
      'id': 21,
      'category': 'fitness',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/09.png',
      'name': 'Basis - Peak Fitness and Sleep Tracker',
      'order_status': 'canceled',
      'popularity': 77,
      'price': 199.99
    },
    {
      'id': 22,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/04.png',
      'name': 'Beats by Dr. Dre - 3\' USB-to-Micro USB Cable',
      'order_status': 'delivered',
      'popularity': 65,
      'price': 19.99
    },
    {
      'id': 23,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/02.png',
      'name': 'Beats by Dr. Dre - Bike Mount for Pill Speakers',
      'order_status': 'delivered',
      'popularity': 60,
      'price': 49.99
    },
    {
      'id': 24,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/06.png',
      'name': 'Beats by Dr. Dre - Support Stand for Speakers',
      'order_status': 'on_hold',
      'popularity': 59,
      'price': 49.99
    },
    {
      'id': 25,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/08.png',
      'name': 'Beats by Dr. Dre - Support Stand for Pill Speakers',
      'order_status': 'on_hold',
      'popularity': 87,
      'price': 49.99
    },
    {
      'id': 26,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/08.png',
      'name': 'Beats by Dr. Dre - Support Stand for Pill Speakers',
      'order_status': 'delivered',
      'popularity': 95,
      'price': 49.99
    },
    {
      'id': 27,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/07.png',
      'name': 'Beats by Dr. Dre - Support Stand for Speakers',
      'order_status': 'canceled',
      'popularity': 98,
      'price': 49.99
    },
    {
      'id': 28,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/04.png',
      'name': 'Beats by Dr. Dre - Support Stand',
      'order_status': 'delivered',
      'popularity': 75,
      'price': 49.99
    },
    {
      'id': 29,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/06.png',
      'name': 'Beats by Dr. Dre - Pill 2.0 Bluetooth Speaker',
      'order_status': 'pending',
      'popularity': 81,
      'price': 199.99
    },
    {
      'id': 30,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/07.png',
      'name': 'Beats by Dr. Dre - Pill 2.0 Bluetooth Speaker',
      'order_status': 'canceled',
      'popularity': 91,
      'price': 199.99
    },
    {
      'id': 31,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/04.png',
      'name': 'Beats by Dr. Dre - Bluetooth Speaker',
      'order_status': 'canceled',
      'popularity': 79,
      'price': 199.99
    },
    {
      'id': 32,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/09.png',
      'name': 'Beats by Dr. Dre - Portable Speaker + Headphones',
      'order_status': 'on_hold',
      'popularity': 95,
      'price': 699.99
    },
    {
      'id': 33,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/03.png',
      'name': 'Beats by Dr. Dre - Pill 2.0 Portable Stereo Speaker',
      'order_status': 'on_hold',
      'popularity': 90,
      'price': 199.99
    },
    {
      'id': 34,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/05.png',
      'name': 'Bose® - SoundLink® III Cover',
      'order_status': 'delivered',
      'popularity': 81,
      'price': 34.99
    },
    {
      'id': 35,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/08.png',
      'name': 'Bose® - Bose® SoundLink® III Cover',
      'order_status': 'delivered',
      'popularity': 81,
      'price': 34.99
    },
    {
      'id': 36,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/05.png',
      'name': 'Bose® - SoundLink® III Cover',
      'order_status': 'on_hold',
      'popularity': 69,
      'price': 34.99
    },
    {
      'id': 37,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/09.png',
      'name': 'Bose® - SoundLink® Mini Soft Cover',
      'order_status': 'canceled',
      'popularity': 95,
      'price': 24.99
    },
    {
      'id': 38,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/01.png',
      'name': 'Bose® - SoundLink® Color Bluetooth Speaker',
      'order_status': 'on_hold',
      'popularity': 100,
      'price': 129.99
    },
    {
      'id': 39,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/01.png',
      'name': 'Bose® - SoundLink® Color Bluetooth Speaker',
      'order_status': 'pending',
      'popularity': 89,
      'price': 129.99
    },
    {
      'id': 40,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/08.png',
      'name': 'Bose® - SoundLink® Color Bluetooth Speaker',
      'order_status': 'pending',
      'popularity': 75,
      'price': 129.99
    },
    {
      'id': 41,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/06.png',
      'name': 'Bose® - SoundLink® Color Bluetooth Speaker',
      'order_status': 'pending',
      'popularity': 54,
      'price': 129.99
    },
    {
      'id': 42,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/04.png',
      'name': 'Bose® - SoundLink® Color Bluetooth Speaker',
      'order_status': 'delivered',
      'popularity': 98,
      'price': 129.99
    },
    {
      'id': 43,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/09.png',
      'name': 'Bose® - SoundLink® Color Carry Case',
      'order_status': 'pending',
      'popularity': 95,
      'price': 24.99
    },
    {
      'id': 44,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/06.png',
      'name': 'Bose® - SoundLink® III Cover',
      'order_status': 'on_hold',
      'popularity': 76,
      'price': 34.99
    },
    {
      'id': 45,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/05.png',
      'name': 'Bose® - SoundLink® III Cover',
      'order_status': 'canceled',
      'popularity': 98,
      'price': 34.99
    },
    {
      'id': 46,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/05.png',
      'name': 'Bose® - SoundLink® III Cover',
      'order_status': 'pending',
      'popularity': 70,
      'price': 34.99
    },
    {
      'id': 47,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/08.png',
      'name': 'Bose® - Mini Bluetooth Speaker II',
      'order_status': 'pending',
      'popularity': 62,
      'price': 199.99
    },
    {
      'id': 48,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/02.png',
      'name': 'Bose® - Bluetooth Speaker II',
      'order_status': 'canceled',
      'popularity': 63,
      'price': 199.99
    },
    {
      'id': 49,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/05.png',
      'name': 'Bose® - SoundLink® Mini Bluetooth Speaker Soft Cover',
      'order_status': 'on_hold',
      'popularity': 90,
      'price': 24.99
    },
    {
      'id': 50,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/04.png',
      'name': 'Bose® - Bluetooth Speaker Soft Cover',
      'order_status': 'canceled',
      'popularity': 98,
      'price': 24.99
    },
    {
      'id': 51,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/09.png',
      'name': 'Bose® - Bluetooth Speaker Soft Cover',
      'order_status': 'on_hold',
      'popularity': 55,
      'price': 24.99
    },
    {
      'id': 52,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/09.png',
      'name': 'Bose® - Bluetooth Speaker',
      'order_status': 'pending',
      'popularity': 53,
      'price': 24.99
    },
    {
      'id': 53,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/09.png',
      'name': 'Bose® - SoundLink® Mini Bluetooth Speaker Soft Cover',
      'order_status': 'pending',
      'popularity': 82,
      'price': 24.99
    },
    {
      'id': 54,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/08.png',
      'name': 'Bose® - Bluetooth Speaker Travel Bag',
      'order_status': 'on_hold',
      'popularity': 78,
      'price': 44.99
    },
    {
      'id': 55,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/08.png',
      'name': 'Bose® - SoundLink® Mini Soft Cover',
      'order_status': 'canceled',
      'popularity': 81,
      'price': 24.99
    },
    {
      'id': 56,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/07.png',
      'name': 'Bose® - SoundLink® Mini Soft Cover',
      'order_status': 'pending',
      'popularity': 94,
      'price': 24.99
    },
    {
      'id': 57,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/09.png',
      'name': 'Bose® - Bluetooth Speaker III',
      'order_status': 'pending',
      'popularity': 97,
      'price': 299.99
    },
    {
      'id': 58,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/04.png',
      'name': 'Bose® - SoundLink® Soft Cover',
      'order_status': 'delivered',
      'popularity': 89,
      'price': 24.99
    },
    {
      'id': 59,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/02.png',
      'name': 'Bose® - Bluetooth Music Adapter',
      'order_status': 'on_hold',
      'popularity': 53,
      'price': 99.99
    },
    {
      'id': 60,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/04.png',
      'name': 'Bowers & Wilkins - Bluetooth Speaker',
      'order_status': 'canceled',
      'popularity': 79,
      'price': 349.98
    },
    {
      'id': 61,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/09.png',
      'name': 'BRAVEN - Balance Portable Bluetooth Speaker',
      'order_status': 'on_hold',
      'popularity': 82,
      'price': 129.99
    },
    {
      'id': 62,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/01.png',
      'name': 'BRAVEN - Balance Portable Bluetooth Speaker',
      'order_status': 'pending',
      'popularity': 80,
      'price': 129.99
    },
    {
      'id': 63,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/06.png',
      'name': 'BRAVEN - Outdoor Speaker',
      'order_status': 'pending',
      'popularity': 86,
      'price': 199.99
    },
    {
      'id': 64,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/03.png',
      'name': 'BRAVEN - BRV-X Outdoor Speaker',
      'order_status': 'pending',
      'popularity': 61,
      'price': 199.99
    },
    {
      'id': 65,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/09.png',
      'name': 'BRAVEN - Portable Bluetooth Speaker',
      'order_status': 'on_hold',
      'popularity': 85,
      'price': 299.99
    },
    {
      'id': 66,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/02.png',
      'name': 'BRAVEN - Portable Bluetooth Speaker',
      'order_status': 'on_hold',
      'popularity': 81,
      'price': 99.99
    },
    {
      'id': 67,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/01.png',
      'name': 'BRAVEN - Wireless Bluetooth Speaker',
      'order_status': 'on_hold',
      'popularity': 50,
      'price': 99.99
    },
    {
      'id': 68,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/02.png',
      'name': 'BRAVEN - Wireless Bluetooth Speaker',
      'order_status': 'delivered',
      'popularity': 93,
      'price': 99.99
    },
    {
      'id': 69,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/03.png',
      'name': 'BRAVEN - Wireless Bluetooth Speaker',
      'order_status': 'pending',
      'popularity': 51,
      'price': 99.99
    },
    {
      'id': 70,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/05.png',
      'name': 'Craig - Tower Speaker',
      'order_status': 'pending',
      'popularity': 77,
      'price': 69.99
    },
    {
      'id': 71,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/04.png',
      'name': 'Craig - Portable Wireless Speaker',
      'order_status': 'canceled',
      'popularity': 89,
      'price': 29.99
    },
    {
      'id': 72,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/09.png',
      'name': 'Definitive Technology - Wireless Speaker',
      'order_status': 'pending',
      'popularity': 81,
      'price': 399.98
    },
    {
      'id': 73,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/03.png',
      'name': 'Definitive Technology - Wireless Speaker',
      'order_status': 'pending',
      'popularity': 76,
      'price': 699.98
    },
    {
      'id': 74,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/08.png',
      'name': 'Denon - Wireless Speaker',
      'order_status': 'pending',
      'popularity': 88,
      'price': 399.98
    },
    {
      'id': 75,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/09.png',
      'name': 'Denon - HEOS 7 Wireless Speaker',
      'order_status': 'canceled',
      'popularity': 100,
      'price': 599.98
    },
    {
      'id': 76,
      'category': 'audio',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/02.png',
      'name': 'ECOXGEAR - Waterproof Bluetooth Speaker',
      'order_status': 'canceled',
      'popularity': 52,
      'price': 129.99
    },
    {
      'id': 77,
      'category': 'fitness',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/03.png',
      'name': 'Fitbit - Charge HR Activity Tracker + Heart Rate (Large)',
      'order_status': 'pending',
      'popularity': 66,
      'price': 149.99
    },
    {
      'id': 78,
      'category': 'fitness',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/01.png',
      'name': 'Fitbit - Charge HR Activity Tracker + Heart Rate (Large)',
      'order_status': 'delivered',
      'popularity': 66,
      'price': 149.99
    },
    {
      'id': 79,
      'category': 'fitness',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/09.png',
      'name': 'Fitbit - Activity Tracker + Heart Rate (Large)',
      'order_status': 'canceled',
      'popularity': 96,
      'price': 149.99
    },
    {
      'id': 80,
      'category': 'fitness',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/01.png',
      'name': 'Fitbit - Charge HR Activity Tracker + Heart Rate (Small)',
      'order_status': 'on_hold',
      'popularity': 92,
      'price': 149.99
    },
    {
      'id': 81,
      'category': 'fitness',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/09.png',
      'name': 'Fitbit - Charge HR Activity Tracker + Heart Rate (Small)',
      'order_status': 'delivered',
      'popularity': 82,
      'price': 149.99
    },
    {
      'id': 82,
      'category': 'fitness',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/01.png',
      'name': 'Fitbit - Activity Tracker + Heart Rate (Small)',
      'order_status': 'pending',
      'popularity': 100,
      'price': 149.99
    },
    {
      'id': 83,
      'category': 'fitness',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/01.png',
      'name': 'Fitbit - Activity Tracker + Sleep Wristband',
      'order_status': 'pending',
      'popularity': 100,
      'price': 149.99
    },
    {
      'id': 84,
      'category': 'fitness',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/02.png',
      'name': 'Fitbit - Activity Tracker (Large)',
      'order_status': 'pending',
      'popularity': 52,
      'price': 129.99
    },
    {
      'id': 85,
      'category': 'fitness',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/05.png',
      'name': 'Fitbit - Charge Wireless Activity Tracker (Large)',
      'order_status': 'on_hold',
      'popularity': 51,
      'price': 129.99
    },
    {
      'id': 86,
      'category': 'fitness',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/04.png',
      'name': 'Fitbit - Charge Wireless Activity Tracker (Large)',
      'order_status': 'pending',
      'popularity': 80,
      'price': 129.99
    },
    {
      'id': 87,
      'category': 'fitness',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/02.png',
      'name': 'Fitbit - Charge Wireless Activity Tracker (Small)',
      'order_status': 'on_hold',
      'popularity': 99,
      'price': 129.99
    },
    {
      'id': 88,
      'category': 'fitness',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/07.png',
      'name': 'Fitbit - Activity Tracker (Small)',
      'order_status': 'on_hold',
      'popularity': 75,
      'price': 129.99
    },
    {
      'id': 89,
      'category': 'fitness',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/07.png',
      'name': 'Fitbit - Charge Wireless Activity Tracker (Small)',
      'order_status': 'pending',
      'popularity': 80,
      'price': 129.99
    },
    {
      'id': 90,
      'category': 'fitness',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/07.png',
      'name': 'Fitbit - Charging Cable for Activity Trackers',
      'order_status': 'delivered',
      'popularity': 50,
      'price': 19.99
    },
    {
      'id': 91,
      'category': 'fitness',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/09.png',
      'name': 'Fitbit - Clip for Activity and Sleep Trackers',
      'order_status': 'delivered',
      'popularity': 57,
      'price': 14.99
    },
    {
      'id': 92,
      'category': 'fitness',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/05.png',
      'name': 'Fitbit - Clip for Wireless Activity and Sleep Trackers',
      'order_status': 'on_hold',
      'popularity': 80,
      'price': 14.99
    },
    {
      'id': 93,
      'category': 'fitness',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/03.png',
      'name': 'Fitbit - Clip for Zip Wireless Activity Trackers',
      'order_status': 'canceled',
      'popularity': 78,
      'price': 14.99
    },
    {
      'id': 94,
      'category': 'fitness',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/05.png',
      'name': 'Fitbit - Flex 1" USB Charging Cable',
      'order_status': 'on_hold',
      'popularity': 81,
      'price': 14.99
    },
    {
      'id': 95,
      'category': 'fitness',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/03.png',
      'name': 'Fitbit - Flex 1" USB Charging Cable',
      'order_status': 'canceled',
      'popularity': 51,
      'price': 14.99
    },
    {
      'id': 96,
      'category': 'fitness',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/03.png',
      'name': 'Fitbit - Flex Clasp for Activity Trackers',
      'order_status': 'canceled',
      'popularity': 56,
      'price': 4.99
    },
    {
      'id': 97,
      'category': 'fitness',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/07.png',
      'name': 'Fitbit - Sleep Wristband',
      'order_status': 'on_hold',
      'popularity': 95,
      'price': 99.99
    },
    {
      'id': 98,
      'category': 'fitness',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/09.png',
      'name': 'Fitbit - Sleep Tracker Wristband',
      'order_status': 'delivered',
      'popularity': 85,
      'price': 99.99
    },
    {
      'id': 99,
      'category': 'fitness',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/09.png',
      'name': 'Fitbit - Flex Wireless Activity',
      'order_status': 'pending',
      'popularity': 50,
      'price': 99.99
    },
    {
      'id': 100,
      'category': 'fitness',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/06.png',
      'name': 'Fitbit - Activity Tracker',
      'order_status': 'delivered',
      'popularity': 72,
      'price': 99.99
    }
  ],
  students: [
    {
      'id': 1,
      'category': 'computers',
      'img': require('@/assets/images/portrait/small/avatar-s-1.jpg'),
      'firstname': 'Hagmon',
      'middlename': '',
      'lastname': 'John',
      'nickname': 'Jazz',
      'dob': '07/15/2000',
      'updatedat': '03/21/2012',
      'status': 'Disabled',
      'order_status': 'on_hold',
      'updatedby': 'sylvia',
      'popularity': 97,
      'price': 69.99,
      'program': 'Photography',
      'room': 'Room1',
      'cam_user': 'Adams Baker',
      'location': 'Manhattan',
      'cameras': cameras,
      'schedules': '',
      'siblings': [
        {
          id: 2,
          img: require('@/assets/images/portrait/small/avatar-s-2.jpg'),
          name: 'John Wick',
        }
      ],
      'camusers': [
        {
          id: '1',
          firstname: 'Williuam',
          middlename: '',
          lastname: 'John',
          avatar: require('@/assets/images/portrait/small/avatar-s-1.jpg'),
          email: 'will@xyz.com',
          phone: '(601) 555-5111',
          student: '',
          status: '',
          econtact: true
        },
        {
          id: '2',
          firstname: 'Brain',
          middlename: '',
          lastname: 'Carry',
          avatar: require('@/assets/images/portrait/small/avatar-s-2.jpg'),
          email: 'will@xyz.com',
          phone: '(601) 5555-111',
          student: '',
          status: '',
          econtact: false
        },
        {
          id: '3',
          firstname: 'John',
          middlename: '',
          lastname: 'Brain',
          avatar: require('@/assets/images/portrait/small/avatar-s-3.jpg'),
          email: 'will@xyz.com',
          phone: '(601) 555-1511',
          student: '',
          status: '',
          econtact: true
        },
        {
          id: '4',
          firstname: 'Carry',
          middlename: '',
          lastname: 'Williuam',
          avatar: require('@/assets/images/portrait/small/avatar-s-4.jpg'),
          email: 'will@xyz.com',
          phone: '(601) 555-4111',
          student: '',
          status: '',
          econtact: false
        },
      ],
      settings: {
        loginlimit: 4,
      }
    },
    {
      'id': 2,
      'category': 'fitness',
      'img': require('@/assets/images/portrait/small/avatar-s-2.jpg'),
      'firstname': 'John',
      'middlename': '',
      'lastname': 'Wick',
      'nickname': 'Jazz',
      'dob': '07/15/2000',
      'updatedat': '03/21/2012',
      'status': 'Disabled',
      'order_status': 'delivered',
      'updatedby': 'sylvia',
      'popularity': 83,
      'price': 69.99,
      'program': 'Art',
      'room': 'Room1',
      'cam_user': 'Clark Davis',
      'location': 'The Bronx',
      'cameras': cameras,
      'schedules': '',
      'siblings': [
        {
          id: 2,
          img: require('@/assets/images/portrait/small/avatar-s-2.jpg'),
          name: 'John Wick',
        }
      ],
      'camusers': [
        {
          id: '3',
          firstname: 'John',
          middlename: '',
          lastname: 'Brain',
          avatar: require('@/assets/images/portrait/small/avatar-s-3.jpg'),
          email: 'will@xyz.com',
          phone: '(601) 555-1171',
          student: '',
          status: '',
          econtact: true
        },
        {
          id: '4',
          firstname: 'Carry',
          middlename: '',
          lastname: 'Williuam',
          avatar: require('@/assets/images/portrait/small/avatar-s-4.jpg'),
          email: 'will@xyz.com',
          phone: '(601) 555-1191',
          student: '',
          status: '',
          econtact: false
        },
      ],
      settings: {
        loginlimit: 5,
      }
    },
    {
      'id': 3,
      'category': 'audio',
      'img': require('@/assets/images/portrait/small/avatar-s-3.jpg'),
      'firstname': 'Lansing',
      'middlename': '',
      'lastname': 'John',
      'nickname': 'Jazz',
      'dob': '07/15/2000',
      'updatedat': '03/21/2012',
      'status': 'Disabled',
      'order_status': 'canceled',
      'updatedby': 'sylvia',
      'popularity': 57,
      'price': 199.99,
      'program': 'Music',
      'room': 'Room2',
      'cam_user': 'Evans Frank',
      'location': 'Brooklyn',
      'cameras': cameras,
      'schedules': '',
      'siblings': [
        {
          id: 2,
          img: require('@/assets/images/portrait/small/avatar-s-2.jpg'),
          name: 'John Wick',
        }
      ],
      'camusers': [
        {
          id: '1',
          firstname: 'Williuam',
          middlename: '',
          lastname: 'John',
          avatar: require('@/assets/images/portrait/small/avatar-s-1.jpg'),
          email: 'will@xyz.com',
          phone: '(601) 555-1101',
          student: '',
          status: '',
          econtact: true
        },
        {
          id: '2',
          firstname: 'Brain',
          middlename: '',
          lastname: 'Carry',
          avatar: require('@/assets/images/portrait/small/avatar-s-2.jpg'),
          email: 'will@xyz.com',
          phone: '(601) 555-6111',
          student: '',
          status: '',
          econtact: false
        },
      ],
      settings: {
        loginlimit: 5,
      }
    },
    {
      'id': 4,
      'category': 'audio',
      'img': require('@/assets/images/portrait/small/avatar-s-4.jpg'),
      'firstname': 'Brian',
      'middlename': '',
      'lastname': 'John',
      'nickname': 'Jazz',
      'dob': '07/15/2000',
      'updatedat': '03/21/2012',
      'status': 'Disabled',
      'order_status': 'on_hold',
      'updatedby': 'sylvia',
      'popularity': 65,
      'price': 199.99,
      'program': 'Photography',
      'room': 'Room2',
      'cam_user': 'Evans Frank',
      'location': 'Queens',
      'cameras': cameras,
      'schedules': '',
      'siblings': [

      ],
      'camusers': [
        {
          id: '3',
          firstname: 'John',
          middlename: '',
          lastname: 'Brain',
          avatar: require('@/assets/images/portrait/small/avatar-s-3.jpg'),
          email: 'will@xyz.com',
          phone: '(601) 555-7111',
          student: '',
          status: '',
          econtact: true
        },
        {
          id: '4',
          firstname: 'Carry',
          middlename: '',
          lastname: 'Williuam',
          avatar: require('@/assets/images/portrait/small/avatar-s-4.jpg'),
          email: 'will@xyz.com',
          phone: '(601) 555-1511',
          student: '',
          status: '',
          econtact: false
        },
      ],
      settings: {
        loginlimit: 4,
      }
    },
    {
      'id': 5,
      'category': 'audio',
      'img': require('@/assets/images/portrait/small/avatar-s-5.jpg'),
      'firstname': 'Jack',
      'middlename': '',
      'lastname': 'Mah',
      'nickname': 'Jazz',
      'dob': '07/15/2000',
      'updatedat': '03/21/2012',
      'status': 'Disabled',
      'order_status': 'canceled',
      'updatedby': 'sylvia',
      'popularity': 87,
      'price': 199.99,
      'program': 'Music',
      'room': 'Room3',
      'cam_user': 'Ghosh Hills',
      'location': 'Staten Island',
      'cameras': cameras,
      'schedules': '',
      'siblings': [

      ],
      'camusers': [
        {
          id: '1',
          firstname: 'Williuam',
          middlename: '',
          lastname: 'John',
          avatar: require('@/assets/images/portrait/small/avatar-s-1.jpg'),
          email: 'will@xyz.com',
          phone: '(601) 555-1311',
          student: '',
          status: '',
          econtact: true
        },
        {
          id: '2',
          firstname: 'Brain',
          middlename: '',
          lastname: 'Carry',
          avatar: require('@/assets/images/portrait/small/avatar-s-2.jpg'),
          email: 'will@xyz.com',
          phone: '(601) 555-1181',
          student: '',
          status: '',
          econtact: false
        },
      ],
      settings: {
        loginlimit: 4,
      }
    },
    {
      'id': 6,
      'category': 'audio',
      'img': require('@/assets/images/portrait/small/avatar-s-6.jpg'),
      'firstname': 'Elon',
      'middlename': '',
      'lastname': 'Gor',
      'nickname': 'Jazz',
      'dob': '07/15/2000',
      'updatedat': '03/21/2012',
      'status': 'Disabled',
      'order_status': 'pending',
      'updatedby': 'sylvia',
      'popularity': 55,
      'price': 39.99,
      'program': 'Dancing',
      'room': 'Room3',
      'cam_user': 'Ghosh Hills',
      'cameras': cameras,
      'schedules': '',
      'location': 'Manhattan',
      'siblings': [
        {
          id: 2,
          img: require('@/assets/images/portrait/small/avatar-s-2.jpg'),
          name: 'John Wick',
        }
      ],
      'camusers': [
        {
          id: '3',
          firstname: 'John',
          middlename: '',
          lastname: 'Brain',
          avatar: require('@/assets/images/portrait/small/avatar-s-3.jpg'),
          email: 'will@xyz.com',
          phone: '(601) 555-1114',
          student: '',
          status: '',
          econtact: true
        },
        {
          id: '4',
          firstname: 'Carry',
          middlename: '',
          lastname: 'Williuam',
          avatar: require('@/assets/images/portrait/small/avatar-s-4.jpg'),
          email: 'will@xyz.com',
          phone: '(601) 555-1131',
          student: '',
          status: '',
          econtact: false
        },
      ],
      settings: {
        loginlimit: 7,
      }
    },
    {
      'id': 7,
      'category': 'audio',
      'img': require('@/assets/images/portrait/small/avatar-s-7.jpg'),
      'firstname': 'John',
      'middlename': '',
      'lastname': 'Red',
      'nickname': 'Jazz',
      'dob': '07/15/2000',
      'updatedat': '03/21/2012',
      'status': 'Disabled',
      'order_status': 'pending',
      'updatedby': 'sylvia',
      'popularity': 99,
      'price': 39.99,
      'program': 'Gym',
      'room': 'Room4',
      'cam_user': 'Irwin Jones',
      'location': 'The Bronx',
      'cameras': cameras,
      'schedules': '',
      'siblings': [
        {
          id: 2,
          img: require('@/assets/images/portrait/small/avatar-s-2.jpg'),
          name: 'John Wick',
        }
      ],
      'camusers': [
        {
          id: '1',
          firstname: 'Williuam',
          middlename: '',
          lastname: 'John',
          avatar: require('@/assets/images/portrait/small/avatar-s-1.jpg'),
          email: 'will@xyz.com',
          phone: '(601) 555-1101',
          student: '',
          status: '',
          econtact: true
        },
        {
          id: '2',
          firstname: 'Brain',
          middlename: '',
          lastname: 'Carry',
          avatar: require('@/assets/images/portrait/small/avatar-s-2.jpg'),
          email: 'will@xyz.com',
          phone: '(601) 555-1411',
          student: '',
          status: '',
          econtact: false
        },
      ],
      settings: {
        loginlimit: 5,
      }
    },
    {
      'id': 8,
      'category': 'audio',
      'img': require('@/assets/images/portrait/small/avatar-s-8.jpg'),
      'firstname': 'John',
      'middlename': '',
      'lastname': 'Walter',
      'nickname': 'Jazz',
      'dob': '07/15/2000',
      'updatedat': '03/21/2012',
      'status': 'Disabled',
      'order_status': 'on_hold',
      'updatedby': 'sylvia',
      'popularity': 91,
      'price': 39.99,
      'program': 'Photography',
      'room': 'Room4',
      'cam_user': 'Klein Lopez',
      'location': 'Brooklyn',
      'cameras': cameras,
      'schedules': '',
      'siblings': [

      ],
      'camusers': [
        {
          id: '3',
          firstname: 'John',
          middlename: '',
          lastname: 'Brain',
          avatar: require('@/assets/images/portrait/small/avatar-s-3.jpg'),
          email: 'will@xyz.com',
          phone: '(601) 555-1121',
          student: '',
          status: '',
          econtact: true
        },
        {
          id: '4',
          firstname: 'Carry',
          middlename: '',
          lastname: 'Williuam',
          avatar: require('@/assets/images/portrait/small/avatar-s-4.jpg'),
          email: 'will@xyz.com',
          phone: '(601) 555-1181',
          student: '',
          status: '',
          econtact: false
        },
      ],
      settings: {
        loginlimit: 5,
      }
    },
    {
      'id': 9,
      'category': 'audio',
      'img': require('@/assets/images/portrait/small/avatar-s-9.jpg'),
      'firstname': 'John',
      'middlename': '',
      'lastname': 'Hector',
      'nickname': 'Jazz',
      'dob': '07/15/2000',
      'updatedat': '03/21/2012',
      'status': 'Disabled',
      'order_status': 'on_hold',
      'updatedby': 'sylvia',
      'popularity': 52,
      'price': 39.99,
      'program': 'Photography',
      'room': 'Room5',
      'cam_user': 'Mason Nalty',
      'location': 'Queens',
      'cameras': cameras,
      'schedules': '',
      'siblings': [

      ],
      'camusers': [
        {
          id: '1',
          firstname: 'Williuam',
          middlename: '',
          lastname: 'John',
          avatar: require('@/assets/images/portrait/small/avatar-s-1.jpg'),
          email: 'will@xyz.com',
          phone: '(601) 555-1511',
          student: '',
          status: '',
          econtact: true
        },
        {
          id: '2',
          firstname: 'Brain',
          middlename: '',
          lastname: 'Carry',
          avatar: require('@/assets/images/portrait/small/avatar-s-2.jpg'),
          email: 'will@xyz.com',
          phone: '(601) 555-1111',
          student: '',
          status: '',
          econtact: false
        },
      ],
      settings: {
        loginlimit: 4,
      }
    },
    {
      'id': 10,
      'category': 'audio',
      'img': require('@/assets/images/portrait/small/avatar-s-10.jpg'),
      'firstname': 'Raymond',
      'middlename': '',
      'lastname': 'Vad',
      'nickname': 'Jazz',
      'dob': '07/15/2000',
      'updatedat': '03/21/2012',
      'status': 'Disabled',
      'order_status': 'delivered',
      'updatedby': 'sylvia',
      'popularity': 64,
      'price': 39.99,
      'program': 'Art',
      'room': 'Room5',
      'cam_user': 'Ochoa Hills',
      'location': 'Staten Island',
      'cameras': cameras,
      'schedules': '',
      'siblings': [
        {
          id: 2,
          img: require('@/assets/images/portrait/small/avatar-s-2.jpg'),
          name: 'John Wick',
        }
      ],
      'camusers': [
        {
          id: '3',
          firstname: 'John',
          middlename: '',
          lastname: 'Brain',
          avatar: require('@/assets/images/portrait/small/avatar-s-3.jpg'),
          email: 'will@xyz.com',
          phone: '(601) 555-1101',
          student: '',
          status: '',
          econtact: true
        },
        {
          id: '4',
          firstname: 'Carry',
          middlename: '',
          lastname: 'Williuam',
          avatar: require('@/assets/images/portrait/small/avatar-s-4.jpg'),
          email: 'will@xyz.com',
          phone: '(601) 555-1112',
          student: '',
          status: '',
          econtact: false
        },
      ],
      settings: {
        loginlimit: 1,
      }
    },
    {
      'id': 11,
      'category': 'audio',
      'img': require('@/assets/images/portrait/small/avatar-s-11.jpg'),
      'firstname': 'Igrak',
      'middlename': '',
      'lastname': 'Ja',
      'nickname': 'Jazz',
      'dob': '07/15/2000',
      'updatedat': '03/21/2012',
      'status': 'Disabled',
      'order_status': 'on_hold',
      'updatedby': 'sylvia',
      'popularity': 93,
      'price': 99.99,
      'program': 'Photography',
      'room': 'Room6',
      'cam_user': 'Quinn Reily',
      'location': 'Manhattan',
      'cameras': cameras,
      'schedules': '',
      'siblings': [

      ],
      'camusers': [
        {
          id: '1',
          firstname: 'Williuam',
          middlename: '',
          lastname: 'John',
          avatar: require('@/assets/images/portrait/small/avatar-s-1.jpg'),
          email: 'will@xyz.com',
          phone: '(601) 555-1171',
          student: '',
          status: '',
          econtact: true
        },
        {
          id: '2',
          firstname: 'Brain',
          middlename: '',
          lastname: 'Carry',
          avatar: require('@/assets/images/portrait/small/avatar-s-2.jpg'),
          email: 'will@xyz.com',
          phone: '(601) 555-1111',
          student: '',
          status: '',
          econtact: false
        },
      ],
      settings: {
        loginlimit: 5,
      }
    },
    {
      'id': 12,
      'category': 'audio',
      'img': require('@/assets/images/portrait/small/avatar-s-12.jpg'),
      'firstname': 'Tom',
      'middlename': '',
      'lastname': 'Hank',
      'nickname': 'Jazz',
      'dob': '07/15/2000',
      'updatedat': '03/21/2012',
      'status': 'Disabled',
      'order_status': 'delivered',
      'updatedby': 'sylvia',
      'popularity': 75,
      'price': 99.99,
      'program': 'Art',
      'room': 'Room6',
      'location': 'The Bronx',
      'cam_user': '',
      'cameras': cameras,
      'schedules': '',
      'siblings': [
        {
          id: 2,
          img: require('@/assets/images/portrait/small/avatar-s-2.jpg'),
          name: 'John Wick',
        }
      ],
      'camusers': [
        {
          id: '1',
          firstname: 'Williuam',
          middlename: '',
          lastname: 'John',
          avatar: require('@/assets/images/portrait/small/avatar-s-1.jpg'),
          email: 'will@xyz.com',
          phone: '(601) 555-1141',
          student: '',
          status: '',
          econtact: true
        },
        {
          id: '2',
          firstname: 'Brain',
          middlename: '',
          lastname: 'Carry',
          avatar: require('@/assets/images/portrait/small/avatar-s-2.jpg'),
          email: 'will@xyz.com',
          phone: '(601) 555-1101',
          student: '',
          status: '',
          econtact: false
        },
      ],
      settings: {
        loginlimit: 2,
      }
    }
  ],
  cam_users: [
    {
      'id': 1,
      'category': 'computers',
      'img': require('@/assets/images/portrait/small/avatar-s-1.jpg'),
      'student': 'Hagmon',
      'popularity': 97,
      'price': 69.99,
      'program': 'Photography',
      'room': 'Room1',
      'username': '',
      'firstname': 'Adams',
      'middlename': '',
      'lastname': 'Baker',
      'email': 'user1@mail.com',
      'email_confirmed': true,
      'order_status': false,
      'phone': '(111) 111-1181',
      'emergency_contact': true,
      'location': 'Manhattan',
      'updatedby': 'Sylvia',
      'updatedat': '03/21/2012',
      'active': true,
      'schedules': '',
      'students': [
        {
          'id': 1,
          'category': 'computers',
          'img': require('@/assets/images/portrait/small/avatar-s-1.jpg'),
          'firstname': 'Hagmon',
          'middlename': '',
          'lastname': 'John',
          'nickname': 'Jazz',
          'dob': '07/15/2000',
          'updatedat': '03/21/2012',
          'status': 'Disabled',
          'order_status': 'on_hold',
          'updatedby': 'sylvia',
          'popularity': 97,
          'price': 69.99,
          'program': 'Photography',
          'room': 'Room1',
          'cam_user': 'Adams Baker',
          'cameras': cameras,
        },
        {
          'id': 2,
          'category': 'fitness',
          'img': require('@/assets/images/portrait/small/avatar-s-2.jpg'),
          'firstname': 'John',
          'middlename': '',
          'lastname': 'Wick',
          'nickname': 'Jazz',
          'dob': '07/15/2000',
          'updatedat': '03/21/2012',
          'status': 'Disabled',
          'order_status': 'delivered',
          'updatedby': 'sylvia',
          'popularity': 83,
          'price': 69.99,
          'program': 'Art',
          'room': 'Room1',
          'cam_user': 'Clark Davis',
          'cameras': cameras,
        },
        {
          'id': 3,
          'category': 'audio',
          'img': require('@/assets/images/portrait/small/avatar-s-3.jpg'),
          'firstname': 'Lansing',
          'middlename': '',
          'lastname': 'John',
          'nickname': 'Jazz',
          'dob': '07/15/2000',
          'updatedat': '03/21/2012',
          'status': 'Disabled',
          'order_status': 'canceled',
          'updatedby': 'sylvia',
          'popularity': 57,
          'price': 199.99,
          'program': 'Music',
          'room': 'Room2',
          'cam_user': 'Evans Frank',
          'cameras': cameras,
        },
      ],
      setting:
      {
        'max_daily_logins': 2,
      }
      ,
      'locations': 'Staten Island'
    },
    {
      'id': 2,
      'category': 'fitness',
      'img': require('@/assets/images/portrait/small/avatar-s-2.jpg'),
      'student': 'John Wick',
      'popularity': 83,
      'price': 69.99,
      'program': 'Art',
      'room': 'Room1',
      'username': '',
      'firstname': 'Clark',
      'middlename': '',
      'lastname': 'Davis',
      'email': 'user2@mail.com',
      'email_confirmed': false,
      'order_status': true,
      'phone': '(111) 222-1211',
      'location': 'The Bronx',
      'updatedby': 'Sylvia',
      'updatedat': '03/21/2012',
      'active': false,
      'schedules': '',
      'students': [
        {
          'id': 1,
          'category': 'computers',
          'img': require('@/assets/images/portrait/small/avatar-s-1.jpg'),
          'firstname': 'Hagmon',
          'middlename': '',
          'lastname': 'John',
          'nickname': 'Jazz',
          'dob': '07/15/2000',
          'updatedat': '03/21/2012',
          'status': 'Disabled',
          'order_status': 'on_hold',
          'updatedby': 'sylvia',
          'popularity': 97,
          'price': 69.99,
          'program': 'Photography',
          'room': 'Room1',
          'cam_user': 'Adams Baker',
          'cameras': cameras,
        },
        {
          'id': 2,
          'category': 'fitness',
          'img': require('@/assets/images/portrait/small/avatar-s-2.jpg'),
          'firstname': 'John',
          'middlename': '',
          'lastname': 'Wick',
          'nickname': 'Jazz',
          'dob': '07/15/2000',
          'updatedat': '03/21/2012',
          'status': 'Disabled',
          'order_status': 'delivered',
          'updatedby': 'sylvia',
          'popularity': 83,
          'price': 69.99,
          'program': 'Art',
          'room': 'Room1',
          'cam_user': 'Clark Davis',
          'cameras': cameras,
        },
        {
          'id': 3,
          'category': 'audio',
          'img': require('@/assets/images/portrait/small/avatar-s-3.jpg'),
          'firstname': 'Lansing',
          'middlename': '',
          'lastname': 'John',
          'nickname': 'Jazz',
          'dob': '07/15/2000',
          'updatedat': '03/21/2012',
          'status': 'Disabled',
          'order_status': 'canceled',
          'updatedby': 'sylvia',
          'popularity': 57,
          'price': 199.99,
          'program': 'Music',
          'room': 'Room2',
          'cam_user': 'Evans Frank',
          'cameras': cameras,
        },
      ],
      setting:
      {
        'max_daily_logins': 5,
      },
      'locations': 'Staten,Manha'
    },
    {
      'id': 3,
      'category': 'audio',
      'img': require('@/assets/images/portrait/small/avatar-s-3.jpg'),
      'student': 'Lansing',
      'popularity': 57,
      'price': 199.99,
      'program': 'Music',
      'room': 'Room2',
      'username': '',
      'firstname': 'Evans',
      'middlename': '',
      'lastname': 'Frank',
      'email': 'user3@mail.com',
      'email_confirmed': true,
      'order_status': false,
      'phone': '(111) 333-1131',
      'location': 'Brooklyn',
      'updatedby': 'Sylvia',
      'updatedat': '03/21/2012',
      'active': true,
      'schedules': '',
      'students': [
        {
          'id': 1,
          'category': 'computers',
          'img': require('@/assets/images/portrait/small/avatar-s-1.jpg'),
          'firstname': 'Hagmon',
          'middlename': '',
          'lastname': 'John',
          'nickname': 'Jazz',
          'dob': '07/15/2000',
          'updatedat': '03/21/2012',
          'status': 'Disabled',
          'order_status': 'on_hold',
          'updatedby': 'sylvia',
          'popularity': 97,
          'price': 69.99,
          'program': 'Photography',
          'room': 'Room1',
          'cam_user': 'Adams Baker',
          'cameras': cameras,
        },
        {
          'id': 2,
          'category': 'fitness',
          'img': require('@/assets/images/portrait/small/avatar-s-2.jpg'),
          'firstname': 'John',
          'middlename': '',
          'lastname': 'Wick',
          'nickname': 'Jazz',
          'dob': '07/15/2000',
          'updatedat': '03/21/2012',
          'status': 'Disabled',
          'order_status': 'delivered',
          'updatedby': 'sylvia',
          'popularity': 83,
          'price': 69.99,
          'program': 'Art',
          'room': 'Room1',
          'cam_user': 'Clark Davis',
          'cameras': cameras,
        },
        {
          'id': 3,
          'category': 'audio',
          'img': require('@/assets/images/portrait/small/avatar-s-3.jpg'),
          'firstname': 'Lansing',
          'middlename': '',
          'lastname': 'John',
          'nickname': 'Jazz',
          'dob': '07/15/2000',
          'updatedat': '03/21/2012',
          'status': 'Disabled',
          'order_status': 'canceled',
          'updatedby': 'sylvia',
          'popularity': 57,
          'price': 199.99,
          'program': 'Music',
          'room': 'Room2',
          'cam_user': 'Evans Frank',
          'cameras': cameras,
        },
      ],
      setting:
      {
        'max_daily_logins': 3,
      },
      'locations': 'Island,attan'
    },
    {
      'id': 4,
      'category': 'audio',
      'img': require('@/assets/images/portrait/small/avatar-s-4.jpg'),
      'student': 'Brian',
      'popularity': 65,
      'price': 199.99,
      'program': 'Photography',
      'room': 'Room2',
      'username': '',
      'firstname': 'Evans',
      'middlename': '',
      'lastname': 'Frank',
      'email': 'user4@mail.com',
      'email_confirmed': false,
      'order_status': true,
      'phone': '(111) 444-1118',
      'location': 'Manhattan',
      'updatedby': 'Sylvia',
      'updatedat': '03/21/2012',
      'active': false,
      'schedules': '',
      'students': [
        {
          'id': 1,
          'category': 'computers',
          'img': require('@/assets/images/portrait/small/avatar-s-1.jpg'),
          'firstname': 'Hagmon',
          'middlename': '',
          'lastname': 'John',
          'nickname': 'Jazz',
          'dob': '07/15/2000',
          'updatedat': '03/21/2012',
          'status': 'Disabled',
          'order_status': 'on_hold',
          'updatedby': 'sylvia',
          'popularity': 97,
          'price': 69.99,
          'program': 'Photography',
          'room': 'Room1',
          'cam_user': 'Adams Baker',
          'cameras': cameras,
        },
        {
          'id': 2,
          'category': 'fitness',
          'img': require('@/assets/images/portrait/small/avatar-s-2.jpg'),
          'firstname': 'John',
          'middlename': '',
          'lastname': 'Wick',
          'nickname': 'Jazz',
          'dob': '07/15/2000',
          'updatedat': '03/21/2012',
          'status': 'Disabled',
          'order_status': 'delivered',
          'updatedby': 'sylvia',
          'popularity': 83,
          'price': 69.99,
          'program': 'Art',
          'room': 'Room1',
          'cam_user': 'Clark Davis',
          'cameras': cameras,
        },
        {
          'id': 3,
          'category': 'audio',
          'img': require('@/assets/images/portrait/small/avatar-s-3.jpg'),
          'firstname': 'Lansing',
          'middlename': '',
          'lastname': 'John',
          'nickname': 'Jazz',
          'dob': '07/15/2000',
          'updatedat': '03/21/2012',
          'status': 'Disabled',
          'order_status': 'canceled',
          'updatedby': 'sylvia',
          'popularity': 57,
          'price': 199.99,
          'program': 'Music',
          'room': 'Room2',
          'cam_user': 'Evans Frank',
          'cameras': cameras,
        },
      ],
      setting:
      {
        'max_daily_logins': 5,
      },
      'locations': 'Queen'
    },
    {
      'id': 5,
      'category': 'audio',
      'img': require('@/assets/images/portrait/small/avatar-s-5.jpg'),
      'student': 'Jack Ma',
      'popularity': 87,
      'price': 199.99,
      'program': 'Music',
      'room': 'Room3',
      'username': '',
      'firstname': 'Ghosh',
      'middlename': '',
      'lastname': 'Hills',
      'email': 'user5@mail.com',
      'email_confirmed': true,
      'order_status': false,
      'phone': '(111) 555-1151',
      'location': 'Queens',
      'updatedby': 'Sylvia',
      'updatedat': '03/21/2012',
      'active': true,
      'schedules': '',
      'students': [
        {
          'id': 1,
          'category': 'computers',
          'img': require('@/assets/images/portrait/small/avatar-s-1.jpg'),
          'firstname': 'Hagmon',
          'middlename': '',
          'lastname': 'John',
          'nickname': 'Jazz',
          'dob': '07/15/2000',
          'updatedat': '03/21/2012',
          'status': 'Disabled',
          'order_status': 'on_hold',
          'updatedby': 'sylvia',
          'popularity': 97,
          'price': 69.99,
          'program': 'Photography',
          'room': 'Room1',
          'cam_user': 'Adams Baker',
          'cameras': cameras,
        },
        {
          'id': 2,
          'category': 'fitness',
          'img': require('@/assets/images/portrait/small/avatar-s-2.jpg'),
          'firstname': 'John',
          'middlename': '',
          'lastname': 'Wick',
          'nickname': 'Jazz',
          'dob': '07/15/2000',
          'updatedat': '03/21/2012',
          'status': 'Disabled',
          'order_status': 'delivered',
          'updatedby': 'sylvia',
          'popularity': 83,
          'price': 69.99,
          'program': 'Art',
          'room': 'Room1',
          'cam_user': 'Clark Davis',
          'cameras': cameras,
        },
        {
          'id': 3,
          'category': 'audio',
          'img': require('@/assets/images/portrait/small/avatar-s-3.jpg'),
          'firstname': 'Lansing',
          'middlename': '',
          'lastname': 'John',
          'nickname': 'Jazz',
          'dob': '07/15/2000',
          'updatedat': '03/21/2012',
          'status': 'Disabled',
          'order_status': 'canceled',
          'updatedby': 'sylvia',
          'popularity': 57,
          'price': 199.99,
          'program': 'Music',
          'room': 'Room2',
          'cam_user': 'Evans Frank',
          'cameras': cameras,
        },
      ],
      setting:
      {
        'max_daily_logins': 6,
      },
      'locations': 'Manhattan'
    },

  ],
  locations: [
    {
      "id": 1,
      "name": "The Bronx",
      "manager": "Tom Hank",
      "settings":
      {
        'max_daily_logins': 8,
        'user_time_out': '1 hr',
        "max_no_of_student": '10',
      },
      schedules: '',
      cameras: [
        {
          "id": 1,
          "code": "#25454545",
          "manager": "Tom Hank",
          "name": "Playground",
          "location": "Manhattan",
          "color_code": "#4a0d66",
          "setting":
          {
            'max_daily_logins': 3,
          },
        },
        {
          "id": 2,
          "code": "#25454545",
          "manager": "Quinn Reily",
          "name": "Meeting Room",
          "location": "Manhattan",
          "camera_id": "@32242",
          "color_code": "#a80b0b",
          "setting":
          {
            'max_daily_logins': 5,
          },
        },

      ]
    },
    {
      "id": 2,
      "name": "Manhattan",
      "manager": "Quinn Reily",

      "settings":
      {
        'max_daily_logins': 7,
        'user_time_out': '30 min',
        "max_no_of_student": '10',
      },
      schedules: '',
      cameras: [
        {
          "id": 3,
          "code": "#zdf42342",
          "name": "Office",
          "location": "Manhattan",
          "camera_id": "@32242",
          "color_code": "#1bc546",
          "setting":
          {
            'max_daily_logins': 6,
          },
        },
        {
          "id": 4,
          "code": "#sfs234",
          "name": "1st floor left room",
          "location": "Manhattan",
          "camera_id": "@32242",
          "color_code": "#3a0909",
          "setting":
          {
            'max_daily_logins': 8,
          },
        },
        {
          "id": 5,
          "code": "#sdf34",
          "name": "2nd floor left room",
          "location": "The Bronx",
          "camera_id": "@32242",
          "color_code": "#a80b0b",
          "setting":
          {
            'max_daily_logins': 3,
          },
        }


      ]

    },

    {
      "id": 3,
      "name": "Brooklyn",
      "manager": "Ochoa Hills",
      "settings":
      {
        'max_daily_logins': 5,
        'user_time_out': '0 min',
        "max_no_of_student": '10',
      },
      schedules: '',
      cameras: [
        {
          "id": 4,
          "code": "#sfs234",
          "name": "1st floor left room",
          "location": "Manhattan",
          "camera_id": "@32242",
          "color_code": "#3a0909",
          "setting":
          {
            'max_daily_logins': 8,
          },
        },
        {
          "id": 5,
          "code": "#sdf34",
          "name": "2nd floor left room",
          "location": "The Bronx",
          "camera_id": "@32242",
          "color_code": "#a80b0b",
          "setting":
          {
            'max_daily_logins': 3,
          },
        }
      ]
    },
    {
      "id": 4,
      "name": "Queens",
      "manager": "Mason Nalty",
      "settings":
      {
        'max_daily_logins': 3,
        'user_time_out': '1 hr',
        "max_no_of_student": '10',

      },
      schedules: '',
      cameras: [
        {
          "id": 1,
          "code": "#25454545",
          "manager": "Tom Hank",
          "name": "Playground",
          "color_code": "#4a0d66",
          "setting":
          {
            'max_daily_logins': 3,
          },
        },
        {
          "id": 5,
          "code": "#sdf34",
          "name": "2nd floor left room",
          "location": "The Bronx",
          "camera_id": "@32242",
          "color_code": "#a80b0b",
          "setting":
          {
            'max_daily_logins': 3,
          },
        }
      ]
    },
    {
      "id": 5,
      "name": "Staten Island",
      "manager": "Tom Hank",
      "settings":
      {
        'max_daily_logins': 1,
        'user_time_out': '30 min',
        "max_no_of_student": '10',
      },
      schedules: '',
      cameras: [
        {
          "id": 1,
          "code": "#25454545",
          "manager": "Tom Hank",
          "name": "Playground",
          "color_code": "#4a0d66",
          "setting":
          {
            'max_daily_logins': 3,
          },
        },
        {
          "id": 3,
          "code": "#zdf42342",
          "name": "Office",
          "location": "Manhattan",
          "camera_id": "@32242",
          "color_code": "#1bc546",
          "setting":
          {
            'max_daily_logins': 6,
          },
        },
      ]
    }
  ],
  programs: [
    {
      "id": 1,
      "name": "Photgraphy",
      "location": "The Bronx"

    },
    {
      "id": 2,
      "name": "Art",
      "location": "Manhattan",
    },

  ],
  managers: [
    {
      'id': 1,
      'img': require('@/assets/images/portrait/small/avatar-s-1.jpg'),
      'status': true,
      'email_confirmed': false,
      'name': 'Adams Baker',
      'middle_name': 'Igrak',
      'nickname': 'baki',
      'username': 'baker',
      'email': 'user1@mail.com',
      'phone': '(111) 111-1111',
      locations: [{
        "id": 1,
        "name": "The Bronx",
        "manager": "Tom Hank",
        "settings":
        {
          'max_daily_logins': 13,
          'user_time_out': '1 hr',
        }
      },
      {
        "id": 2,
        "name": "Manhattan",
        "manager": "Quinn Reily",
        "settings":
        {
          'max_daily_logins': 12,
          'user_time_out': '30 min',

        }
      },]

    },
    {
      'id': 2,
      'img': require('@/assets/images/portrait/small/avatar-s-3.jpg'),
      'status': false,
      'email_confirmed': true,
      'name': 'Igrak Ja',
      'middle_name': 'Igrak',
      'nickname': 'baki',
      'username': 'baker',
      'email': 'Igrak@mail.com',
      'phone': '(111) 134-1111',
      locations: [{
        "id": 1,
        "name": "The Bronx",
        "manager": "Tom Hank",
        "settings":
        {
          'max_daily_logins': 13,
          'user_time_out': '1 hr',
        }
      },
      ]

    },


  ],
  schedules: [
    {
      id: 2,
      name: "First Schedule",
      dates: {
        Monday: [
          {
            "start_time": "11:55 AM",
            "end_time": "10:00 PM",
          }
        ],
        Tuesday: [{
          "start_time": "11:55 AM",
          "end_time": "10:00 PM",
        }
        ],
        Wednesday: [{
          "start_time": "10:00 AM",
          "end_time": "11:00 PM",
        }
        ], Thursday: [{
          "start_time": "10:00 AM",
          "end_time": "11:00 PM",
        }
        ], Friday: [{
          "start_time": "05:00 AM",
          "end_time": "05:00 PM",
        }
        ], Saturday: [{
          "start_time": "03:00 AM",
          "end_time": "05:00 PM",
        }
        ], Sunday: [{
          "start_time": "06:00 AM",
          "end_time": "09:00 PM",
        }
        ],
      },

    },
    {
      id: 3,
      name: "Second Schedule",
      dates: {
        Monday: [
          {
            "start_time": "11:55 AM",
            "end_time": "10:00 PM",
          }
        ],
        Tuesday: [{
          "start_time": "",
          "end_time": "",
        }
        ],
        Wednesday: [{
          "start_time": "10:00 AM",
          "end_time": "11:00 PM",
        }
        ], Thursday: [{
          "start_time": "10:00 AM",
          "end_time": "11:00 PM",
        }
        ], Friday: [{
          "start_time": "05:00 AM",
          "end_time": "05:00 PM",
        }
        ], Saturday: [{
          "start_time": "03:00 AM",
          "end_time": "05:00 PM",
        }
        ], Sunday: [{
          "start_time": "06:00 AM",
          "end_time": "09:00 PM",
        }
        ],
      },

    },

  ],
  cameras: [
    {
      "id": 1,
      "code": "#25454545",
      "manager": "Tom Hank",
      "name": "Playground",
      "color_code": "#4a0d66",
      "setting":
      {
        'max_daily_logins': 3,
      },
      schedule:
      {
        id: 2,
        name: "First Schedule",
        dates: {
          monday: [
            {
              "start_time": "11:55 AM",
              "end_time": "10:00 PM",
            }
          ],
          tuesday: [{
            "start_time": "",
            "end_time": "",
          }
          ],
          wednesday: [{
            "start_time": "10:00 AM",
            "end_time": "11:00 PM",
          }
          ], thursday: [{
            "start_time": "10:00 AM",
            "end_time": "11:00 PM",
          }
          ], friday: [{
            "start_time": "05:00 AM",
            "end_time": "05:00 PM",
          }
          ], saturday: [{
            "start_time": "03:00 AM",
            "end_time": "05:00 PM",
          }
          ], sunday: [{
            "start_time": "06:00 AM",
            "end_time": "09:00 PM",
          }
          ],
        },

      }


    },
    {
      "id": 2,
      "code": "#25454545",
      "manager": "Quinn Reily",
      "name": "Meeting Room",
      "location": "Manhattan",
      "camera_id": "@32242",
      "color_code": "#a80b0b",
      "setting":
      {
        'max_daily_logins': 5,
      },
      schedule:
      {
        id: 2,
        name: "First Schedule",
        dates: {
          monday: [
            {
              "start_time": "11:55 AM",
              "end_time": "10:00 PM",
            }
          ],
          tuesday: [{
            "start_time": "",
            "end_time": "",
          }
          ],
          wednesday: [{
            "start_time": "10:00 AM",
            "end_time": "11:00 PM",
          }
          ], thursday: [{
            "start_time": "10:00 AM",
            "end_time": "11:00 PM",
          }
          ], friday: [{
            "start_time": "05:00 AM",
            "end_time": "05:00 PM",
          }
          ], saturday: [{
            "start_time": "03:00 AM",
            "end_time": "05:00 PM",
          }
          ], sunday: [{
            "start_time": "06:00 AM",
            "end_time": "09:00 PM",
          }
          ],
        },

      }
    },
    {
      "id": 3,
      "code": "#zdf42342",
      "name": "Office",
      "location": "Manhattan",
      "camera_id": "@32242",
      "color_code": "#1bc546",
      "setting":
      {
        'max_daily_logins': 6,
      },
      schedule:
      {
        id: 2,
        name: "First Schedule",
        dates: {
          monday: [
            {
              "start_time": "11:55 AM",
              "end_time": "10:00 PM",
            }
          ],
          tuesday: [{
            "start_time": "",
            "end_time": "",
          }
          ],
          wednesday: [{
            "start_time": "10:00 AM",
            "end_time": "11:00 PM",
          }
          ], thursday: [{
            "start_time": "10:00 AM",
            "end_time": "11:00 PM",
          }
          ], friday: [{
            "start_time": "05:00 AM",
            "end_time": "05:00 PM",
          }
          ], saturday: [{
            "start_time": "03:00 AM",
            "end_time": "05:00 PM",
          }
          ], sunday: [{
            "start_time": "06:00 AM",
            "end_time": "09:00 PM",
          }
          ],
        },

      }
    },
    {
      "id": 4,
      "code": "#sfs234",
      "name": "1st floor left room",
      "location": "Manhattan",
      "camera_id": "@32242",
      "color_code": "#3a0909",
      "setting":
      {
        'max_daily_logins': 8,
      },
      schedule:
      {
        id: 2,
        name: "First Schedule",
        dates: {
          monday: [
            {
              "start_time": "11:55 AM",
              "end_time": "10:00 PM",
            }
          ],
          tuesday: [{
            "start_time": "",
            "end_time": "",
          }
          ],
          wednesday: [{
            "start_time": "10:00 AM",
            "end_time": "11:00 PM",
          }
          ], thursday: [{
            "start_time": "10:00 AM",
            "end_time": "11:00 PM",
          }
          ], friday: [{
            "start_time": "05:00 AM",
            "end_time": "05:00 PM",
          }
          ], saturday: [{
            "start_time": "03:00 AM",
            "end_time": "05:00 PM",
          }
          ], sunday: [{
            "start_time": "06:00 AM",
            "end_time": "09:00 PM",
          }
          ],
        },

      }
    },
    {
      "id": 5,
      "code": "#sdf34",
      "name": "2nd floor left room",
      "location": "The Bronx",
      "camera_id": "@32242",
      "color_code": "#a80b0b",
      "setting":
      {
        'max_daily_logins': 3,
      },
      schedule:
      {
        id: 2,
        name: "First Schedule",
        dates: {
          monday: [
            {
              "start_time": "11:55 AM",
              "end_time": "10:00 PM",
            }
          ],
          tuesday: [{
            "start_time": "",
            "end_time": "",
          }
          ],
          wednesday: [{
            "start_time": "10:00 AM",
            "end_time": "11:00 PM",
          }
          ], thursday: [{
            "start_time": "10:00 AM",
            "end_time": "11:00 PM",
          }
          ], friday: [{
            "start_time": "05:00 AM",
            "end_time": "05:00 PM",
          }
          ], saturday: [{
            "start_time": "03:00 AM",
            "end_time": "05:00 PM",
          }
          ], sunday: [{
            "start_time": "06:00 AM",
            "end_time": "09:00 PM",
          }
          ],
        },

      }
    }
  ]
}
mock.onGet('/api/data-list/products').reply(() => {
  return [200, JSON.parse(JSON.stringify(data.products)).reverse()]
})

// POST : Add new Item
mock.onPost('/api/data-list/products/').reply((request) => {

  // Get event from post data
  const item = JSON.parse(request.data).item

  const length = data.products.length
  let lastIndex = 0
  if (length) {
    lastIndex = data.products[length - 1].id
  }
  item.id = lastIndex + 1

  data.products.push(item)

  return [201, { id: item.id }]
})

// Update Product
mock.onPost(/\/api\/data-list\/products\/\d+/).reply((request) => {

  const itemId = request.url.substring(request.url.lastIndexOf('/') + 1)

  const item = data.products.find((item) => item.id == itemId)
  Object.assign(item, JSON.parse(request.data).item)

  return [200, item]
})

// DELETE: Remove products
mock.onDelete(/\/api\/data-list\/products\/\d+/).reply((request) => {

  const itemId = request.url.substring(request.url.lastIndexOf('/') + 1)

  const itemIndex = data.products.findIndex((p) => p.id == itemId)
  data.products.splice(itemIndex, 1)
  return [200]
})


////Students
mock.onGet('/api/data-list/students').reply(() => {
  return [200, JSON.parse(JSON.stringify(data.students)).reverse()]
})
mock.onGet('/api/data-list/studentbyid').reply(() => {
  return [200, JSON.parse(JSON.stringify(data.students)).reverse()]
})

// POST : Add new Student
mock.onPost('/api/data-list/students/').reply((request) => {

  // Get event from post data
  const item = JSON.parse(request.data).item

  const length = data.students.length
  let lastIndex = 0
  if (length) {
    lastIndex = data.students[length - 1].id
  }
  item.id = lastIndex + 1

  data.students.push(item)

  return [201, { id: item.id }]
})

// Update students
mock.onPost(/\/api\/data-list\/students\/\d+/).reply((request) => {

  const itemId = request.url.substring(request.url.lastIndexOf('/') + 1)

  const item = data.students.find((item) => item.id == itemId)
  Object.assign(item, JSON.parse(request.data).item)

  return [200, item]
})

// DELETE: Remove students
mock.onDelete(/\/api\/data-list\/students\/\d+/).reply((request) => {

  const itemId = request.url.substring(request.url.lastIndexOf('/') + 1)

  const itemIndex = data.students.findIndex((p) => p.id == itemId)
  data.students.splice(itemIndex, 1)
  return [200]
})


////CAM USERS
mock.onGet('/api/data-list/cam_users').reply(() => {
  return [200, JSON.parse(JSON.stringify(data.cam_users)).reverse()]
})

// POST : Add new Cam User
mock.onPost('/api/data-list/cam_users/').reply((request) => {

  // Get event from post data
  const item = JSON.parse(request.data).item

  const length = data.cam_users.length
  let lastIndex = 0
  if (length) {
    lastIndex = data.cam_users[length - 1].id
  }
  item.id = lastIndex + 1

  data.cam_users.push(item)

  return [201, { id: item.id }]
})

// Update cam_users
mock.onPost(/\/api\/data-list\/cam_users\/\d+/).reply((request) => {

  const itemId = request.url.substring(request.url.lastIndexOf('/') + 1)

  const item = data.cam_users.find((item) => item.id == itemId)
  Object.assign(item, JSON.parse(request.data).item)

  return [200, item]
})

// DELETE: Remove cam_users
mock.onDelete(/\/api\/data-list\/cam_users\/\d+/).reply((request) => {

  const itemId = request.url.substring(request.url.lastIndexOf('/') + 1)

  const itemIndex = data.cam_users.findIndex((p) => p.id == itemId)
  data.cam_users.splice(itemIndex, 1)
  return [200]
})


////LOCATIONS
mock.onGet('/api/data-list/locations').reply(() => {
  return [200, JSON.parse(JSON.stringify(data.locations)).reverse()]
})

// POST : Add new LOCATION
mock.onPost('/api/data-list/locations/').reply((request) => {

  // Get event from post data
  const item = JSON.parse(request.data).item

  const length = data.locations.length
  let lastIndex = 0
  if (length) {
    lastIndex = data.locations[length - 1].id
  }
  item.id = lastIndex + 1

  data.locations.push(item)

  return [201, { id: item.id }]
})

// Update LOCATION
mock.onPost(/\/api\/data-list\/locations\/\d+/).reply((request) => {

  const itemId = request.url.substring(request.url.lastIndexOf('/') + 1)

  const item = data.locations.find((item) => item.id == itemId)
  Object.assign(item, JSON.parse(request.data).item)

  return [200, item]
})

// DELETE: LOCATION
mock.onDelete(/\/api\/data-list\/locations\/\d+/).reply((request) => {

  const itemId = request.url.substring(request.url.lastIndexOf('/') + 1)

  const itemIndex = data.locations.findIndex((p) => p.id == itemId)
  data.locations.splice(itemIndex, 1)
  return [200]
})



////PROGRAMS
mock.onGet('/api/data-list/programs').reply(() => {
  return [200, JSON.parse(JSON.stringify(data.programs)).reverse()]
})

// POST : Add new PROGRAM
mock.onPost('/api/data-list/programs/').reply((request) => {

  // Get event from post data
  const item = JSON.parse(request.data).item

  const length = data.programs.length
  let lastIndex = 0
  if (length) {
    lastIndex = data.programs[length - 1].id
  }
  item.id = lastIndex + 1

  data.programs.push(item)

  return [201, { id: item.id }]
})

// Update PROGRAM
mock.onPost(/\/api\/data-list\/program\/\d+/).reply((request) => {

  const itemId = request.url.substring(request.url.lastIndexOf('/') + 1)

  const item = data.programs.find((item) => item.id == itemId)
  Object.assign(item, JSON.parse(request.data).item)

  return [200, item]
})

// DELETE: PROGRAM
mock.onDelete(/\/api\/data-list\/program\/\d+/).reply((request) => {

  const itemId = request.url.substring(request.url.lastIndexOf('/') + 1)

  const itemIndex = data.programs.findIndex((p) => p.id == itemId)
  data.programs.splice(itemIndex, 1)
  return [200]
})



////MANAGERS
mock.onGet('/api/data-list/managers').reply(() => {
  return [200, JSON.parse(JSON.stringify(data.managers)).reverse()]
})

// POST : Add new MANAGER
mock.onPost('/api/data-list/managers/').reply((request) => {

  // Get event from post data
  const item = JSON.parse(request.data).item

  const length = data.managers.length
  let lastIndex = 0
  if (length) {
    lastIndex = data.managers[length - 1].id
  }
  item.id = lastIndex + 1

  data.managers.push(item)

  return [201, { id: item.id }]
})

// Update MANAGER
mock.onPost(/\/api\/data-list\/manager\/\d+/).reply((request) => {

  const itemId = request.url.substring(request.url.lastIndexOf('/') + 1)

  const item = data.managers.find((item) => item.id == itemId)
  Object.assign(item, JSON.parse(request.data).item)

  return [200, item]
})

// DELETE: MANAGER
mock.onDelete(/\/api\/data-list\/manager\/\d+/).reply((request) => {

  const itemId = request.url.substring(request.url.lastIndexOf('/') + 1)

  const itemIndex = data.managers.findIndex((p) => p.id == itemId)
  data.programs.splice(itemIndex, 1)
  return [200]
})



////SCHEDULES
mock.onGet('/api/data-list/schedules').reply(() => {
  return [200, JSON.parse(JSON.stringify(data.schedules)).reverse()]
})

// POST : Add new SCHEDULE
mock.onPost('/api/data-list/schedules/').reply((request) => {

  // Get event from post data
  const item = JSON.parse(request.data).item

  const length = data.schedules.length
  let lastIndex = 0
  if (length) {
    lastIndex = data.schedules[length - 1].id
  }
  item.id = lastIndex + 1

  data.schedules.push(item)

  return [201, { id: item.id }]
})

// Update SCHEDULES
mock.onPost(/\/api\/data-list\/schedules\/\d+/).reply((request) => {

  const itemId = request.url.substring(request.url.lastIndexOf('/') + 1)

  const item = data.locations.find((item) => item.id == itemId)
  Object.assign(item, JSON.parse(request.data).item)

  return [200, item]
})

// DELETE: LOCATION
mock.onDelete(/\/api\/data-list\/schedules\/\d+/).reply((request) => {

  const itemId = request.url.substring(request.url.lastIndexOf('/') + 1)

  const itemIndex = data.schedules.findIndex((p) => p.id == itemId)
  data.schedules.splice(itemIndex, 1)
  return [200]
})


////CAMERAS
mock.onGet('/api/data-list/cameras').reply(() => {
  return [200, JSON.parse(JSON.stringify(data.cameras)).reverse()]
})

// POST : Add new CAMERA
mock.onPost('/api/data-list/cameras/').reply((request) => {

  // Get event from post data
  const item = JSON.parse(request.data).item

  const length = data.cameras.length
  let lastIndex = 0
  if (length) {
    lastIndex = data.cameras[length - 1].id
  }
  item.id = lastIndex + 1

  data.cameras.push(item)

  return [201, { id: item.id }]
})

// Update Camera
mock.onPost(/\/api\/data-list\/cameras\/\d+/).reply((request) => {

  const itemId = request.url.substring(request.url.lastIndexOf('/') + 1)

  const item = data.cameras.find((item) => item.id == itemId)
  Object.assign(item, JSON.parse(request.data).item)

  return [200, item]
})

// DELETE: LOCATION
mock.onDelete(/\/api\/data-list\/cameras\/\d+/).reply((request) => {

  const itemId = request.url.substring(request.url.lastIndexOf('/') + 1)

  const itemIndex = data.cameras.findIndex((p) => p.id == itemId)
  data.cameras.splice(itemIndex, 1)
  return [200]
})

